import { QueryClient } from '@tanstack/react-query'
import axios from 'axios'

import { bridgelessChainInfo, config } from '@/config'

export const bridgelessRestApiClient = axios.create({
  baseURL: bridgelessChainInfo.rest,
  timeout: 15_000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
})

export const bridgelessRpcApiClient = axios.create({
  baseURL: bridgelessChainInfo.rpc,
  timeout: 15_000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
})

export const ipfsApiClient = axios.create({
  baseURL: config.VITE_IPFS_API_URL,
})

export const queryClient = new QueryClient()
